export const FETCH_AGEING_REPORT_REQUEST = 'ageing-report/FETCH_AGEING_REPORT_REQUEST';
export const FETCH_AGEING_REPORT_FAILURE = 'ageing-report/FETCH_AGEING_REPORT_FAILURE';
export const FETCH_AGEING_REPORT_SUCCESS = 'ageing-report/FETCH_AGEING_REPORT_SUCCESS';

//Workspaces tracking
export const FETCH_WORKSPACES = 'ageing-report/FETCH_WORKSPACES';
export const SWITCH_WORKSPACE = 'ageing-report/SWITCH_WORKSPACE'